import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFieldArray, useForm } from "react-hook-form";
import { branch } from "../type";
import { yupResolver } from "@hookform/resolvers/yup";
import { patient } from "../../validations/Validation";
import { getBranches } from "../../services/get.service";
import { postPatient } from "../../services/post.service";
import { toast } from "react-toastify";

export interface IUseCreatePatient {
  onSubmit: (data: any) => void;
  registerGeneral: any;
  registerAddress: any;
  unRegisterAddress: any;
  handleSubmitGeneral: any;
  handleSubmitAddress: any;
  errorsGeneral: any;
  errorsAddress: any;
  branch: any;
  formValue: any;
  setFormValue: any;
  addressFields: any;
  appendAddress: any;
  addressRemove: any;
  loading: boolean;
}

export const useCreatePatient = (): IUseCreatePatient => {
  const [formValue, setFormValue] = useState<any>({});
  const [branch, setBranch] = useState<Array<branch>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    getBranches().then((res) => setBranch(res.data));
  }, []);

  const onSubmit = () => {
    setLoading(true);
    var id = toast.loading("Please wait...", {
      theme: "colored",
      type: "info",
      closeButton: true,
    });

    formValue.risks = formValue?.riskandHabits?.risks?.toString();
    formValue.habits = formValue?.riskandHabits?.habits?.toString();
    delete formValue["riskandHabits"];

    postPatient(formValue)
      .then((res) => {
        toast.update(id, {
          render: "Registered Successfully",
          type: "success",
          theme: "colored",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        toast.warning("Card No - " + res.data, {
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        
        setLoading(false);
        navigate("/search/patient");
      })
      .catch((err) => {
        toast.update(id, {
          render: err?.response?.data?.detail,
          theme: "colored",
          autoClose: 5000,
          type: "error",
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        console.log(err);
      });
  };

  const {
    register: registerGeneral,
    handleSubmit: handleSubmitGeneral,
    control,
    formState: { errors: errorsGeneral },
  } = useForm({
    resolver: yupResolver(patient),
    defaultValues: { addresses: formValue.addresses },
  });

  const {
    register: registerAddress,
    handleSubmit: handleSubmitAddress,
    unregister: unRegisterAddress,
    formState: { errors: errorsAddress },
  } = useForm();

  const {
    fields: addressFields,
    append: addressAppend,
    remove: addressRemove,
  } = useFieldArray({
    control,
    name: "addresses",
  });

  const appendAddress = () => {
    addressAppend({});
  };

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerAddress,
    handleSubmitAddress,
    unRegisterAddress,
    errorsAddress,
    branch,
    appendAddress,
    addressFields,
    addressRemove,
    loading,
  };
};
